<template lang="pug">
	.web-services--script-builder--object-operations.flex-col.space
		.operation.flex-col(v-for="(operation, opIdx) in operations")
			.flex-row.justify
				.upper.grey {{operation.name}}
				.flex-row.space-small
					.add-button.flex-row.align-center.center.clickable.hoverable(@click="moveArrayItem(operations, opIdx, -1)")
						fas(icon="caret-up", size="2xs")
					.add-button.flex-row.align-center.center.clickable.hoverable(@click="moveArrayItem(operations, opIdx, 1)")
						fas(icon="caret-down", size="2xs")
					.add-button.flex-row.align-center.center.clickable.hoverable(@click="operations.splice(opIdx, 1)")
						fas(icon="close", size="2xs")
			.flex-col.space
				.operation.flex-col(v-for="prop in operation.props")
					.font-small.grey(v-if="prop.title") {{prop.title}}
					DxNumberBox(v-if="prop.type === 'number'", :value.sync="prop.value", stylingMode="filled")
					DxCheckBox(v-if="prop.type === 'bool'", :value.sync="prop.value", :text="prop.text")
					DxTextBox(v-if="prop.type === 'fields'", :value.sync="prop.value", stylingMode="filled")
					DxTextBox(v-if="prop.type === 'string'", :value.sync="prop.value", stylingMode="filled")
					DxSelectBox(v-if="prop.type === 'list'", :data-source="prop.list", :value.sync="prop.value", stylingMode="filled")
		.add-button.flex-row.align-center.center.clickable.hoverable(@click="initAddObjectOperation")
			fas(icon="plus", size="2xs")
		Popup(v-if="objectOperationsPopupVisible", :popupVisible.sync="objectOperationsPopupVisible", :width="320", :autosize="true")
			.flex-col.space.web-services--script-builder.web-services--script-builder--object-operations
				.object-operation.flex-col.clickable.hoverable(v-for="operation in objectOperations", @click="confirmAddObjectOperation(operation)")
					.flex-row.justify.align-center
						.upper {{operation.name}}
						fas(icon="plus")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="objectOperationsPopupVisible = false")
</template>

<script>
import _ from 'lodash';
import DxButton from 'devextreme-vue/button';
import JsonViewer from 'json-viewer';
import DxCheckBox from 'devextreme-vue/check-box';
import DxSelectBox from 'devextreme-vue/select-box';
import DxTextBox from 'devextreme-vue/text-box';
import Popup from 'app-core/Popup.vue';
import DxNumberBox from 'devextreme-vue/number-box';

export default {
	translationCategory: 'webServiceCaller.ScriptBuilder',
	components: { DxButton, JsonViewer, DxCheckBox, DxSelectBox, DxTextBox, Popup, DxNumberBox },
	props: ['operations'],
	data() {
		return {
			objectOperations: [
				{ name: 'get', props: { 'field': { type: 'string', value: null, title: this.$tCaption('Field')  } } },
				//{ name: 'convert', props: { 'to': { type: 'list', list: ['date', 'number'] } } },
			],
			objectOperationsPopupVisible: false,
		};
	},
	computed: {
	},
	mounted() {
		if (__DEBUG__)
			window.scriptBuilderObjectOperations = this;
	},
	methods: {
		moveArrayItem(arr, idx, direction) {
			var item = arr[idx];
			arr.splice(idx, 1);
			arr.splice(idx + direction, 0, item);
		},
		initAddObjectOperation() {
			this.objectOperationsPopupVisible = false;
			setImmediate(() => this.objectOperationsPopupVisible = true);
		},
		confirmAddObjectOperation(operation) {
			this.objectOperationsPopupVisible = false;
			this.operations.push(_.cloneDeep(operation));
		},
		
	}
};
</script>
<style lang="scss">
	.web-services--script-builder--object-operations {
		.object-operation {
			margin: 1px;
			background: #efefef;
			border-radius: 4px;
			padding: 8px;
		}
	}
</style>
